export const GuidanceStepRoute = {
  NEXTSTEPS: {
    path: 'nextsteps',
    name: 'nextsteps'
  }
};
